export const NO_SORT = '__no_sort__';

const opt = (s, own) => ({
  value: s.sort_no,
  label: `${s.sort_no}${s.supplier_design_name ? ` · ${s.supplier_design_name}` : ''}`,
  sub: [s.fg_name && `FG ${s.fg_name}`, s.description].filter(Boolean).join(' · '),
  tag: own ? (s.is_default ? 'default' : 'this FG') : undefined,
});

/** A supplier's sort nos for one FG: the FG's own sort nos first (default tagged), then the rest. */
export const sortChoices = (sorts, fg, withNone = true) => {
  const own = (s) => !!fg && s.fg_name === fg;
  return [...(withNone ? [{ value: NO_SORT, label: 'No sort no yet — new design' }] : []),
    ...sorts.filter(own).map((s) => opt(s, true)), ...sorts.filter((s) => !own(s)).map((s) => opt(s, false))];
};

/** The supplier's default sort no for the FG ('Default' = yes in Greige Sort Nos), else its only sort no for the FG. */
export const defaultSort = (sorts, fg) => {
  const mine = sorts.filter((s) => !!fg && s.fg_name === fg);
  return mine.find((s) => s.is_default) || (mine.length === 1 ? mine[0] : null);
};
